const initialState = {
    activeTabId: '',
    tabs: [],
};
export const getInitialState = () => initialState;
//# sourceMappingURL=initialState.js.map